import React from 'react';
import { Col, Row } from 'react-bootstrap';

import catherineSmola1 from '../../../assets/images/catherineSmola1.png';
import ReadMore from '../../components/ReadMore';

const MessageFromPresident = ({ width, isMobile }) => {
  return (
    <Col>
      <Row>
        {!isMobile && width >= 576 && <Member />}
        <Col xs={12} sm={7} md={8} lg={9} xl={9}>
          <Row>
            {!isMobile && width < 576 && <Member />}
            <Col xs={isMobile ? 12 : 7} sm={12}>
              <h2
                style={{ textAlign: 'left' }}
                id="message-from-the-president"
                tabIndex="-1"
              >
                Message from president<br/>& CEO
          </h2>
            </Col>

          </Row>

          <div className="quoteSubheader" style={{ marginTop: 30 }}>
            “2020 was a testament to what can be achieved through innovation, collaboration and determination. If there was one thing to be certain of, it’s that teamwork and partnership are key to moving forward in challenging times.”
          </div>
          <p style={{ marginTop: 30 }}>
            It’s hard to believe over a year has gone by since the pandemic fundamentally shifted us to a virtual workforce. By now, we have all been impacted in some way or another. Despite the challenges we faced, 2020 was a testament to what can be achieved through innovation, collaboration and determination. If there was one thing to be certain of, it’s that teamwork and partnership are key to moving forward in challenging times.
          </p>
          <p>
            It was through the spirit of continuous improvement and the commitment to industry excellence that CSIO was well positioned to serve our members. CSIO works to maintain and evolve data standards that meet the needs of the industry and inspire leading-edge solutions. Maintaining this foundation means being able to serve our members with solutions and services that are fresh, innovative, and advance the P&C insurance industry. In this report, we are pleased to highlight some of these achievements.
          </p>
          <ReadMore href="/message-from-president-and-ceo#top" />
        </Col>
      </Row>
    </Col>
  )
}

export default MessageFromPresident;

const Member = ({ style }) => (
  <Col xs={5} sm={5} md={4} lg={3} xl={3} style={{
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    // paddingRight: 60,
    ...style
  }}>
    <img
      src={catherineSmola1}
      style={{
        width: '100%',
        height: 'auto',
        marginLeft: 40,
        marginRight: 40,
        marginBottom: 25
      }}
      aria-label="picture of Catherine Smola"
    />
    <div className="homepageExecName">
      CATHERINE SMOLA
          </div>
    <div className="homepageExecTitle">
      CSIO President<br/>& CEO
          </div>
  </Col>
);
